<template>
  <div>
    <div v-if="!hasRules" style="padding:12px 0;opacity:0.5;font-style:italic;font-size:13px;">규칙이 정의되지 않았습니다.</div>
    <div v-else style="display:flex;flex-direction:column;gap:14px;">
      <div v-for="(rule, idx) in normalized" :key="idx" style="display:flex;gap:8px;align-items:flex-start;">
        <div style="color:#7367F0;line-height:22px;width:16px;font-weight:600;">▸</div>
        <div style="flex:1;display:flex;flex-direction:column;gap:4px;">
          <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">
            <span style="font-size:11px;text-transform:uppercase;letter-spacing:0.8px;opacity:0.55;font-weight:600;">지역</span>
            <span style="font-weight:500;font-size:13px;">{{ rule.territoryLabel }}</span>
            <span style="opacity:0.4;">→</span>
            <StatusPill :variant="rule.actionVariant"></StatusPill>
          </div>
          <div v-if="rule.condition" style="font-size:12px;opacity:0.65;display:flex;align-items:center;gap:8px;">
            <span style="font-size:10px;text-transform:uppercase;letter-spacing:0.8px;font-weight:600;opacity:0.7;">조건</span>
            <span style="font-family:ui-monospace,'SF Mono',Menlo,Consolas,monospace;background:rgba(115,103,240,0.06);padding:2px 6px;border-radius:3px;color:#1a1f2c;">{{ rule.condition }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusPill from './StatusPill.vue'

function summarizeTerritory(rule) {
  const incl = rule.includedTerritories || []
  const excl = rule.excludedTerritories || []
  if (incl.length === 0 && excl.length === 0) return '전 세계'
  if (incl.length === 0 && excl.length > 0) return `전 세계 (${excl.join(', ')} 제외)`
  if (incl.length > 0 && excl.length === 0) return incl.join(', ')
  return `${incl.join(', ')} (${excl.join(', ')} 제외)`
}

function summarizeCondition(rule) {
  const parts = []
  if (rule.subaction) parts.push(rule.subaction)
  if (rule.match && rule.match.minMatchSeconds) parts.push(`일치 ≥ ${rule.match.minMatchSeconds}초`)
  if (rule.match && rule.match.minMatchPercent) parts.push(`일치 ≥ ${rule.match.minMatchPercent}%`)
  return parts.join(' · ')
}

const ACTION_TO_VARIANT = { block: 'block', monetize: 'monetize', track: 'track' }

export default {
  name: 'PolicyRules',
  components: { StatusPill },
  props: {
    rules: { type: Array, default: () => [] },
  },
  computed: {
    hasRules() {
      return this.normalized.length > 0
    },
    normalized() {
      return (this.rules || [])
        .filter((r) => {
          const type = r && r.conditions && r.conditions.requiredTerritories && r.conditions.requiredTerritories.type
          return type !== 'exclude'
        })
        .map((r) => ({
          territoryLabel: summarizeTerritory(r),
          actionVariant: ACTION_TO_VARIANT[(r.action || '').toLowerCase()] || 'inactive',
          condition: summarizeCondition(r),
        }))
    },
  },
}
</script>
